import { css } from 'emotion'

const selectedItemStyle = selected => {
  if (selected) {
    return css`
      background: #cde6ff;
    `
  }
}

export default selectedItemStyle
